
const driverReport= {
  driverReportTitle: 'דוח נהג',
  id: 'מזהה',
  driver: 'נהג',
  filter: {
    driver: 'נהג',
    car: 'רכב',
    submit: 'סינון',
    export: 'ייצא',
    clear: 'נקה סינון',
    validation: {
      startDateRequired: 'תאריך התחלה נדרש',
      endDateRequired: 'תאריך סיום נדרש',
    },
  },

  table: {
    drivers: 'נהגים',
    vehicles: 'רכבים',
    trips: 'נסיעות',
  },

  vechile: 'רכב',
  pax: 'נוסעים',
  cash: 'מזומן',
  start: 'התחלה',
  end: 'סיום',
  reservations: {
    reservations: 'הזמנות',
    table: {
      from: 'מ-',
      to: 'אל',
      date: 'תאריך',
      passenger: 'נוסע',
      reservation: 'מזהה הזמנה',
      paymentType: 'סוג תשלום',
      pax: 'נוסעים',
      pickup: 'איסוף',
      drop_off: 'הורדה',
      duration: 'משך',
      car: 'רכב',
    },
  },

  form: {
    dateEnd: 'תאריך סיום',
    dateStart: 'תאריך התחלה',
  },
};


export default driverReport;